import { useEffect } from 'react';

export const GradientCanvas = () => {
  useEffect(() => {
    // @ts-ignore
    const gradient = new Gradient();
    gradient.initGradient('#gradient-canvas');
  }, []);
  return (
    <canvas
      id="gradient-canvas"
      className="absolute top-0 left-0 z-0 h-full w-full touch-none select-none"
    />
  );
};
